export default "__VITE_ASSET__DwU93Va8__"